import { connect } from 'react-redux';
import LaporanAbsensiKelas from '../../../views/Student/report/LaporanAbsensiKelas.student.view';
import { manageRegistration } from '../../../states/thunks/student.thunk';
import { getClasses } from '../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
    handleManageRegistration: (payload, push) => dispatch(manageRegistration(payload, push)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(LaporanAbsensiKelas);
